
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic06On as ObiLogic06OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-06-on.js';
 
 
 

 
 export const ObiLogic06On = createComponent({
   react: React,
   tagName: 'obi-logic-06-on',
   elementClass: ObiLogic06OnElement,
   events: {
     
   }
  });
 
 